import { createSlice } from '@reduxjs/toolkit';
import { createCommunityHomeOwnerApi} from '../HomeownerApi';

const HomeOwnerCreateDataSlice = createSlice({
  name: 'HomeOwnerCreateData',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(createCommunityHomeOwnerApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCommunityHomeOwnerApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createCommunityHomeOwnerApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default HomeOwnerCreateDataSlice.reducer;
